import { buildColumnFormatter } from '@spoiler-alert/ui-library';
import VColumn from './v-column';
import { insertColumnBefore } from '../../../components/desirability/desirability-presenter';

export const columnRowAccessField = (column) => {
  if (!column.baseType) return column.field;
  const path = column.path || column.field;
  if (column.baseType === 'Site') return `site.${path}`;
  return path;
};

export const getVTableColumnsFromDataTableProfile = (profileName, site, columnOverrides = {}, insertColumns = []) => {
  const profiles = site.dataTableProfiles;
  const profile = profiles.find((d) => d.dataTableName === profileName);
  if (!profile) throw new Error(`No profile found for the ${profileName} table`);
  const columns = {
    visible: [],
    hidden: [],
  };
  profile.columns.forEach((column) => {
    const { displayName, visible, sortable, defaultSort, defaultSortDirection } = column;
    const field = columnRowAccessField(column);
    const formatter = buildColumnFormatter(column);
    const c = new VColumn({
      field,
      displayName,
      visible,
      sortable,
      defaultSort,
      defaultSortDirection,
      formatter,
      ...columnOverrides[field],
    });
    if (c.visible) {
      columns.visible.push(c);
    } else {
      columns.hidden.push(c);
    }
  });
  // Feature-flagged columns are inserted here rather than configured in the site's profile: a
  // profile is per-site data, so that route would need a migration per site and would let a site
  // remove a column the feature depends on.
  insertColumns.forEach(({ before, column }) => {
    columns.visible = insertColumnBefore(columns.visible, before, column);
  });
  return columns;
};

export const getData = (obj, field) => {
  return field.split('.').reduce((o, i) => o && o[i], obj);
};
